import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './utils/react-dates-override.css'
import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import RegisterPage from './views/Register/RegisterPage/RegisterPage';
import LoginPage from './views/Login/LoginPage/LoginPage';
import RegisterModalPage from './views/RegisterModal/RegisterModalPage/RegisterModalPage';
import EmployesPage from './views/Employes/EmployesPage/EmployesPage';
import Navbar from './components/Navbar/Navbar';
import ViewBar from './components/ViewBar/ViewBar';
import CompanyInfoPage from './views/CompanyInfo/CompanyInfoPage/CompanyInfoPage';
import AppointmentPage from './views/Appointment/AppointmentPage/AppointmentPage';
import FirmsPage from './views/Firms/FirmsPage/FirmsPage';
import PayrollPage from './views/Payroll/PayrollPage/PayrollPage';
import CIRPage from './views/CIR/CIRPage/CIRPage';
import FestivosPage from './views/Festivos/FestivosPage/FestivosPage';
import CreatePersonPage from './views/CreatePerson/CreatePersonPage/CreatePersonPage';
import CreateEmployeePage from './views/CreateEmployee/CreateEmployeePage/CreateEmployeePage';
import OvertimePage from './views/Overtime/OvertimePage/OvertimePage';
import UsersPage from './views/Users/UsersPage/UsersPage';
import Social_benefitsPage from './views/Social_benefits/Social_benefitsPage/Social_benefitsPage';
import ConfBar from './components/ConfBar/ConfBar';
import RenewSession from './components/RenewSession/RenewSession';
import ReportedPage from './views/Reported/ReportedPage/ReportedPage';
import GlobalStyle from './globalStyles'
import PrivateRoute from './PrivateRoute/PrivateRoute';
import PrivateRouteLogin from './PrivateRoute/PrivateRouteLogin';
import StaticPage from './views/Static/StaticPage/StaticPage';
import VacationPage from './views/Vacation/VacationPage/VacationPage';
import LicensesPage from './views/Licenses/LicensesPage/LicensesPage';
import PayrollPaymentPage from './views/PayrollPayment/PayrollPaymentPage/PayrollPaymentPage';
import SocialSecurityPage from './views/SocialSecurity/SocialSecurityPage/SocialSecurityPage';
import AccountingPage from './views/Accounting/AccountingPage/AccountingPage';
import SeverancePage from './views/Severance/SeverancePage/SeverancePage';
import CIR_PayrollPage from './views/CIR_Payroll/CIR_PayrollPage/CIR_PayrollPage';
import Cost_centerPage from './views/Cost_center/Cost_centerPage/Cost_centerPage';
import ThirdPage from './views/Third/ThirdPage/ThirdPage';
import Accounting_accountPage from './views/Accounting_account/Accounting_accountPage/Accounting_accountPage';
import OpenPayrollPage from './views/OpenPayroll/OpenPayrollPage/OpenPayrollPage'
import HistoricPayrollPage from './views/HistoricPayroll/HistoricPayrollPage/HistoricPayrollPage'
import HistoricSocialSecurity from './views/HistoricSocialSecurity/HistoricSocialSecurityPage/HistoricSocialSecurityPage'
import HistoricAccounting from './views/HistoricAccounting/HistoricAccountingPage/HistoricAccountingPage'
import "primereact/resources/themes/lara-light-blue/theme.css";  //theme
import "primereact/resources/primereact.min.css";                  //core css
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import Password_managementPage from './views/Password_management/Password_managementPage/Password_managementPage';
import CertificatePage from './views/Certificate/CertificatePage/CertificatePage';
import VoucherPage from './views/Voucher/VoucherPage/VoucherPage';
import SupportPage from './views/Support/SupportPage/SupportPage'
import ElectronicPayrollPage from './views/ElectronicPayroll/ElectronicPayrollPage/ElectronicPayrollPage';
import ProcessDianPage from './views/ProcessDian/ProcessDianPage/ProcessDianPage';
import VerificationPage from './views/Verification/VerificationPage/VerificationPage';
import Swagger from './swagger/swagger';
import PayOrderPage from './views/PayOrder/PayOrderPage/PayOrderPage';
import WhatsApp from './components/WhatsApp/whatsApp';
import HomePage from './views/Home/HomePage/HomePage';
import CIRVoucherPage from './views/CIRVoucher/CIRVoucherPage/CIRVoucherPage';
import HistoricElectronicPayrollPage from './views/HistoricElectronicPayroll/HistoricElectronicPayrollPage/HistoricElectronicPayrollPage';
import apis from './api';
import InitialBalancePage from './views/InitialBalance/InitialBalancePage/InitialBalancePage';
import ValidateCertificate from './components/ValidateCertificate/ValidateCertificate';
import ReactGA from 'react-ga';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import Menu from './components/Menu/Menu';
import Instances from './components/Instances/Instances';
import VacationProcessPage from './views/VacationProcess/VacationProcessPage/VacationProcessPage';
import AdditionalProcessPage from './views/AdditionalProcess/AdditionalProcessPage/AdditionalProcessPage';
import PlansPage from './views/Plans/PlansPage/PlansPage';
import PilaPage from './views/Pila/PilaPage/PilaPage';
import SalaryChangePage from './views/SalaryChange/SalaryChangePage/SalaryChangePage';
import BanksPage from './views/Banks/BanksPage/BanksPage';
import RetefuentePage from './views/Retefuente/RetefuentePage/RetefuentePage';
import DocumentsPage from './views/Documents/DocumentsPage/DocumentsPage';
import DocumentAdminPage from './views/DocumentAdmin/DocumentAdminPage/DocumentAdminPage';
import AccountingConfPage from './views/AccountingConf/AccountingConfPage/AccountingConfPage';
import ApprovalFlowPage from './views/ApprovalFlow/ApprovalFlowPage/ApprovalFlowPage';
import ShiftConfigurationPage from './views/ShiftConfiguration/ShiftConfigurationPage/ShiftConfigurationPage';
import ApprovalConfPage from './views/ApprovalConf/ApprovalFlowPage/ApprovalConfPage';
import EmployeesNoveltiesPage from './views/EmployeesNovelties/EmployeesNoveltiesPage/EmployeesNoveltiesPage';
import SchedulingPage from './views/Scheduling/SchedulingPage/SchedulingPage';
import MarkingPage from './views/Marking/MarkingPage/MarkingPage';
import OccasionalMarkingPage from './views/OccasionalMarking/OccasionalMarkingPage/OccasionalMarking';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : App
Description : Se llama la barra de navegación, ya que esta es global y se definen las rutas para navegar entre vistas.
Date Autor Modification
================================================================================
23/10/2021 Cristian Andres Pizo Mina Modificación – Se definen las rutas de navegación y se incluye la barra de navegación.
27/10/2021 Santiago Coca Rojas Modificación - Se agregan más rutas para la totalidad de los componenstes definidos hasta la fecha.
28/10/2021 Santiago Coca Rojas Modificación - Se agrega componente de estilos globales,
2/11/2021 Cristian Andres Pizo Mina – Se agrego seguridad para las pantallas con el componente PrivateRoute
================================================================================ */

function App() {

  const [visibleLeft, setVisibleLeft] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (window.location.pathname === '/' || window.location.pathname === '/Login' || window.location.pathname === '/Home' ||
      (window.location.pathname === '/Certificate' && localStorage.getItem('type') === 'CLIENT')) {
      loadVideos();
    }
  }, []);

  const loadVideos = async () => {
    await apis.getVideos().then(res => {
      const videos = res.data.LITE_VIDEOS_APP;
      videos.forEach(video => {
        let nombre = video.detail_id + "_VIDEO"
        let url = video.description
        localStorage.setItem(nombre, url);
      })
    })
  }

  return (
    <Router className="surface-100	">
      <Menu open={open} setOpen={setOpen} />
      <div className="App surface-100	 pb-8">
        <RenewSession />
        <GlobalStyle />
        <Navbar open={open} setOpen={setOpen} />
        {(window.location.pathname === '/' || window.location.pathname === '/Login' || window.location.pathname === '/Register') && <WhatsApp />}
        <div className={open ? 'main-content-open' : 'main-content-close'}>
          <ViewBar />
          <Switch>
            <Route path="/ValidateCertificate/:id" component={ValidateCertificate} />
            <Route exact path="/"><Redirect to="/Login" /></Route>
            <PrivateRouteLogin exact path={"/Login"} component={LoginPage} />
            <Route exact path={"/Register"} component={RegisterPage} />
            <Route exact path={"/CompleteRegister"} component={RegisterModalPage} />
            <PrivateRoute exact path={"/Home"} component={HomePage} />
            <PrivateRoute exact path={"/Employes"} component={EmployesPage} />
            <PrivateRoute exact path={"/CompanyInfo"} component={CompanyInfoPage} />
            <PrivateRoute exact path={"/Jobs"} component={AppointmentPage} />
            <PrivateRoute exact path={"/Firms"} component={FirmsPage} />
            <PrivateRoute exact path={"/Payroll"} component={PayrollPage} />
            <PrivateRoute exact path={"/CIR"} component={CIRPage} />
            <PrivateRoute exact path={"/Festivos"} component={FestivosPage} />
            <PrivateRoute exact path={"/CreatePerson"} component={CreatePersonPage} />
            <PrivateRoute exact path={"/CreateEmployee"} component={CreateEmployeePage} />
            <PrivateRoute exact path={"/Novelties"}><Redirect to="/NoveltiesOvertime" /></PrivateRoute>
            <PrivateRoute exact path={"/NoveltiesOvertime"} component={OvertimePage} />
            <PrivateRoute exact path={"/Users"} component={UsersPage} />
            <PrivateRoute exact path={"/Social_benefitsProcess"} component={Social_benefitsPage} />
            <PrivateRoute exact path={"/NoveltiesReported"} component={ReportedPage} />
            <PrivateRoute exact path={"/NoveltiesStatic"} component={StaticPage} />
            <PrivateRoute exact path={"/NoveltiesVacation"} component={VacationPage} />
            <PrivateRoute exact path={"/NoveltiesLicenses"} component={LicensesPage} />
            <PrivateRoute exact path={"/PayrollPaymentProcess"} component={PayrollPaymentPage} />
            <PrivateRoute exact path={"/SocialSecurity"} component={SocialSecurityPage} />
            <PrivateRoute exact path={"/Accounting"} component={AccountingPage} />
            <PrivateRoute exact path={"/AccountantCost_center"} component={Cost_centerPage} />
            <PrivateRoute exact path={"/AccountantAccount_Plan"} component={Accounting_accountPage} />
            <PrivateRoute exact path={"/Severance"} component={SeverancePage} />
            <PrivateRoute exact path={"/CIR_Payroll"} component={CIR_PayrollPage} />
            <PrivateRoute exact path={"/Password_management"} component={Password_managementPage} />
            <PrivateRoute exact path={"/PasswordManagement"} component={Password_managementPage} />
            <PrivateRoute exact path={"/AccountantThird"} component={ThirdPage} />
            <PrivateRoute exact path={"/OpenPayroll"} component={OpenPayrollPage} />
            <PrivateRoute exact path={"/HistoricPayroll"} component={HistoricPayrollPage} />
            <PrivateRoute exact path={"/PILAHistoricSocialSecurity"} component={HistoricSocialSecurity} />
            <PrivateRoute exact path={"/HistoricAccounting"} component={HistoricAccounting} />
            <PrivateRoute exact path={"/Accountant"}><Redirect to="/AccountantCost_center" /></PrivateRoute>
            <PrivateRoute exact path={"/Support"} component={SupportPage} />
            <PrivateRoute exact path={"/Certificate"} component={CertificatePage} />
            <PrivateRoute exact path={"/Voucher"} component={VoucherPage} />
            <PrivateRoute exact path={"/ElectronicPayroll"} component={ElectronicPayrollPage} />
            <PrivateRoute exact path={"/ProcessDIAN"} component={ProcessDianPage} />
            <PrivateRoute exact path={"/Verification"} component={VerificationPage} />
            <Route exact path={"/APIDocumentation"} component={Swagger} />
            <PrivateRoute exact path={"/PayOrder"} component={PayOrderPage} />
            <PrivateRoute exact path={"/CIRVoucher"} component={CIRVoucherPage} />
            <PrivateRoute exact path={"/HistoricElectronicPayroll"} component={HistoricElectronicPayrollPage} />
            <PrivateRoute exact path={"/InitialBalance"} component={InitialBalancePage} />
            <PrivateRoute exact path={"/TI"} component={Instances} />
            <PrivateRoute exact path={"/VacationProcess"} component={VacationProcessPage} />
            <PrivateRoute exact path={"/AdditionalProcess"} component={AdditionalProcessPage} />
            <PrivateRoute exact path={"/Process"}><Redirect to="/Social_benefitsProcess" /></PrivateRoute>
            <PrivateRoute exact path={"/Plans"} component={PlansPage} />
            <PrivateRoute exact path={"/PILA"}><Redirect to="/PILAHistoricSocialSecurity" /></PrivateRoute>
            <PrivateRoute exact path={"/PILASheets"} component={PilaPage} />
            <PrivateRoute exact path={"/SalaryChange"} component={SalaryChangePage} />
            <PrivateRoute exact path={"/Banks"} component={BanksPage} />
            <PrivateRoute exact path={"/Retefuente"} component={RetefuentePage} />
            <PrivateRoute exact path={"/Documents"} component={DocumentsPage} />
            <PrivateRoute exact path={"/DocumentAdmin"} component={DocumentAdminPage} />
            <PrivateRoute exact path={"/AccountantAccountingConf"} component={AccountingConfPage} />
            <PrivateRoute exact path={"/ApprovalFlow"} component={ApprovalFlowPage} />
            <PrivateRoute exact path={"/ShiftConfiguration"} component={ShiftConfigurationPage} />
            <PrivateRoute exact path={"/ApprovalConfiguration"} component={ApprovalConfPage} />
            <PrivateRoute exact path={"/EmployeesNovelties"} component={EmployeesNoveltiesPage} />
            <PrivateRoute exact path={"/Scheduling"} component={SchedulingPage} />
            <PrivateRoute exact path={"/Marking"} component={MarkingPage} />
            <PrivateRoute exact path={"/OccasionalMarking"} component={OccasionalMarkingPage} />
            <PrivateRoute exact path={"/HistoricOccasionalMarking"} component={OccasionalMarkingPage} />
          </Switch>
        </div>
      </div>
    </Router>
  );
}

export default App;
